// Maps DataWorkflow.Segment → DEPARTMENT_TABS[].id
export const SEGMENT_TO_DEPT = {
  'Digital Marketing': 'digital-marketing',
}

// Maps DEPARTMENT_TABS[].id → DataWorkflow.Segment
export const DEPT_TO_SEGMENT = {
  'digital-marketing': 'Digital Marketing',
}

// Maps DataWorkflow.SubSegment → report.id within that department
export const SUBSEGMENT_TO_REPORT = {
  'Whatsapp Growth Metrics': 'wa-growth',
  'Web Traffic Report': 'web-traffic',
  'Web Traffic Report - UTM Detailed': 'web-traffic-utm',
  'Customer Acquisition & Growth Funnel': 'acquisition-funnel',
  'Top 30 /Promo/ Landing Pages': 'top-landing',
}

// Reverse map: report.id → SubSegment
export const REPORT_TO_SUBSEGMENT = Object.fromEntries(
  Object.entries(SUBSEGMENT_TO_REPORT).map(([k, v]) => [v, k])
)

// The SubSegment value for department overview
export const OVERVIEW_SUBSEGMENT = 'Overview'
